import { FaChartBar, FaList, FaPlus, FaPrint, FaQrcode } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';

import './Navbar.css';

const Navbar = () => {
  const location = useLocation();

  const isActive = (path: string): string =>
    location.pathname === path ? 'active' : '';

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <FaQrcode className="brand-icon" />
          <span>JourneyMeds QR Hub</span>
        </Link>

        <div className="navbar-menu">
          <Link to="/" className={`nav-link ${isActive('/')}`}>
            <FaChartBar />
            <span>Dashboard</span>
          </Link>
          <Link to="/generate" className={`nav-link ${isActive('/generate')}`}>
            <FaPlus />
            <span>Generate</span>
          </Link>
          <Link to="/qr-codes" className={`nav-link ${isActive('/qr-codes')}`}>
            <FaList />
            <span>QR Codes</span>
          </Link>
          <Link to="/print" className={`nav-link ${isActive('/print')}`}>
            <FaPrint />
            <span>Print</span>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
